import api from '@/api/api.js'

export default {
    getAssurances() {
        const promise = api.clinique().get('/assurances')
        return promise.then(response => response.data)
    },

    // Société à convention directe : travailleurs et familles pré-enregistrés (04/10/2026).
    rechercherMembresConvention(assurance_id, q) {
        const promise = api.clinique().get('/assurances/'+assurance_id+'/membres/recherche', { params: { q } })
        return promise.then((response) => response.data)
    },

    // Accueil : assurance, convention ou société absente créée en un geste (04/10/2026).
    // Nouveau travailleur d'une société à convention, ajouté depuis l'accueil (04/10/2026).
    creerMembreConvention(assurance_id, data) {
        return api.clinique().post('/assurances/'+assurance_id+'/membres', data).then((response) => response.data)
    },

    creerAssuranceRapide(data) {
        return api.clinique().post('/assurances/creation-rapide', data).then((response) => response.data)
    },

    creerSouscripteurRapide(assurance_id, data) {
        return api.clinique().post('/assurances/'+assurance_id+'/souscripteurs/creation-rapide', data).then((response) => response.data)
    },

    getSocieteByAssurance(assurance_id) {
        const promise = api.clinique().get('/assurances/souscripteurs/'+assurance_id+'/liste')
        return promise.then((response) => response.data)
    },

    getFactureRembourse(data) {
        const promise = api.clinique().post('/assurances/facture/demande-rembourse', data)
        return promise.then(response => response.data)
    },

    getGroupeAssuranceActif() {
        const promise = api.clinique().get('/groupes/assurances/actif')
        return promise.then(response => response.data)
    },

    getInfoPatientAssure(patient_id) {
        const promise = api.clinique().get('/patients/'+patient_id+'/info_assure')
        return promise.then(response => response.data)
    },

    getSouscripteurGroupByAssurance(data) {
        const promise = api.clinique().post('/assurances/liste-souscripteurs', data)
        return promise.then(response => response.data)
    },

    updateSouscripteursForfaitaires(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-liste-forfaitaires', data)
        return promise.then(response => response.data)
    },

    updateMontantForfaitaire(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-montant-forfaitaires', data)
        return promise.then(response => response.data)
    },

    updateInfoSociete(data) {
        const promise = api.clinique().post('/assurances/souscripteurs/update-info-societe', data)
        return promise.then(response => response.data)
    },

    getInfoSocieteByID(societe_id) {
        const promise = api.clinique().get('/assurances/souscripteurs/' + societe_id + '/get-info-societe')
        return promise.then(response => response.data)
    },
}